"use client";

import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDFc4k_o1CtFW0mmwjlVP6geN1emIZEl0s",
  authDomain: "mistry-bhai.firebaseapp.com",
  projectId: "mistry-bhai",
  storageBucket: "mistry-bhai.firebasestorage.app",
  messagingSenderId: "477922714866",
  appId: "1:477922714866:web:4133559844710048205c6b",
  measurementId: "G-M706VHXSWP",
};

export const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);

let appCheckStarted = false;

export async function startAppCheck() {
  if (typeof window === "undefined" || appCheckStarted) return appCheckStarted;
  const viteEnv = (import.meta as ImportMeta & { env?: Record<string, string | undefined> }).env;
  const siteKey = viteEnv?.VITE_FIREBASE_APPCHECK_SITE_KEY;
  if (!siteKey) return false;
  const { ReCaptchaEnterpriseProvider, initializeAppCheck } = await import("firebase/app-check");
  initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaEnterpriseProvider(siteKey),
    isTokenAutoRefreshEnabled: true,
  });
  appCheckStarted = true;
  return true;
}

export async function startAnalytics() {
  if (typeof window === "undefined") return;
  try {
    const { getAnalytics, isSupported } = await import("firebase/analytics");
    if (await isSupported()) getAnalytics(firebaseApp);
  } catch {
    // Analytics is optional and must never interrupt an emergency flow.
  }
}
